//
//
//
//
//
//
//
//
//


export default {
	name: 'divline',
	data() {
		return {

		}
	},
	mounted(){

	}
}



// WEBPACK FOOTER //
// ./src/components/ui/divline.vue